import { render, staticRenderFns } from "./dismissed-case-request.vue?vue&type=template&id=7f488ab1&"
import script from "./dismissed-case-request.vue?vue&type=script&lang=js&"
export * from "./dismissed-case-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports